import { useReactFlow } from '@xyflow/react';
import { useKeyboardShortcut } from '@/features/canvas/engine/hooks/use-keyboard-shortcut';

export function useCutShortcut(onCut: (ids: string[]) => void) {
  const { getNodes } = useReactFlow();
  useKeyboardShortcut(
    { key: 'x', meta: true },
    (e) => {
      const selected = getNodes().filter((n) => n.selected).map((n) => n.id);
      if (selected.length === 0) return;
      e.preventDefault();
      onCut(selected);
    },
  );
}
